<script lang="ts">
  import { usePopover } from '../use-popover.svelte';
  import { PopoverProvider, PopoverOptionsProvider } from '../use-popover-context';
  import { css } from '@agapi/ui/panda/css';
  import type { PopoverRootProps } from '../popover.types';

  const { open, children, fullWidth, ...props }: PopoverRootProps = $props();

  const id = $props.id();

  const popover = usePopover({ ...props, id });
  PopoverProvider(popover);
  PopoverOptionsProvider({ fullWidth: fullWidth || false });

  $effect(() => {
    if (open !== undefined) {
      popover.api.setOpen(open);
    }
  });
</script>

<div class={css({position: 'relative', display: 'flex'})}>
  {#if children}
    {@render children()}
  {/if}
</div>
